import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';
import {DoctorService} from '../../services/doctor.service';
import {Serviceprovider} from '../../classes/serviceprovider.interface';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-doctordetail',
  templateUrl: './doctordetail.component.html',
  styleUrls: ['./doctordetail.component.css']
})
export class DoctordetailComponent implements OnInit {
  finalfees= [];
  consfees: string;
  specialist: any;
  sid: number;
  doctor: Serviceprovider;
  public loading = false;
  servicemenu: any;
  services = [];
  special = [];
  special2 = [];

  constructor(private route: ActivatedRoute, private doctorService: DoctorService, private commonService:
  CommonService, private router: Router) {
    this.consfees = "Not Set";
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.sid = id;
       });
  }

  ngOnInit() {
    this.getDoctorDetail();
    this.getAllServiceMenus();
    this.getSpecialist();
  }
  getDoctorDetail() {
    this.loading = true;
    this.doctorService.getDoctorsDetail(this.sid)
    .subscribe(
      (x: Serviceprovider) => {
        this.loading = false;
        this.doctor = x;
      });
  }
  getAllServiceMenus() {
    this.doctorService.getServiceMenus(this.sid)
    .subscribe (
      (x) => {
        this.servicemenu = x;
        for(let i = 0; i < this.servicemenu.length; i++) {
          if(this.servicemenu[i].fees === 0){
              this.finalfees.push({"id": this.servicemenu[i].id,"service_id": this.servicemenu[i].service_id ,
              "fees": this.consfees})
          } else {
            this.finalfees.push({"id": this.servicemenu[i].id, "service_id": this.servicemenu[i].service_id,
            "fees": this.servicemenu[i].fees})
          }
        }
        this.getDoctorService();
      });
  }
  getDoctorService() {
    this.doctorService.getAllServicess()
    .subscribe (
      (x) => {
       this.services = x;
      });
  }
  getSetSpecialisation() {
    this.doctorService.getSpecialisation()
    .subscribe (
      (x) => {
        for (let i = 0 ; i < x.length; i++) {
          this.special.push(x[i]);
        }
        this.eliminateSpecialisation();
      });
  }
  eliminateSpecialisation() {
    for (let i = 0 ; i  < this. specialist.length ; i++) {
      for ( let j = 0; j < this.special.length ; j ++) {
        if (this.special[j].id === this.specialist[i]. specialisation_id) {
          this.special2.push(this.special[j]);
        }
      }
    }
  }
  getSpecialist() {
    this.loading = true;
    this.doctorService.GetMyAvailableSpecialisation(this.sid)
    .subscribe(
      (x) => {
        this.specialist = x;
        this.loading = false;
        this.getSetSpecialisation();
      }
    )
  }
  bookAppointment(id) {
    const flag = 7
    this.commonService.setActivatepath(flag);
     this.router.navigate(['/pulse/AppointmentBooking/' + id]);
  }
}
